import React from "react";
import {confirmAlert} from "react-confirm-alert";
import {faPaperclip} from "@fortawesome/free-solid-svg-icons/faPaperclip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import DocumentHyperLink from "../../assets/DocumentHyperLink.png";

const Dialog = styled.div`
    max-width: 800px;
    width:100% !Important;
`;

const sectionStyle = {
    width: '25px',
    height: '25px',
};

export default (function PaperClipIcon(props){
    const {links} = props;

    function paperClipConfirm(){
        confirmAlert({
            customUI: ({onClose}) => {
                return(
                    <Dialog>
                        <div className="confirmation--toolbar">

                            <div className="confirmation--title">Links</div>

                         <div className="confirmation--close"><FontAwesomeIcon icon={faTimes} size="lg" onClick={onClose} pull={"right"}/></div>
                        </div>

                        <div className="confirmation--body">
                            {links && links.map(link =>
                                <a href={link.link} target="_blank">{link.linkTitle}<br/></a>
                            )}

                        </div>
                    </Dialog>

                )
            }
        })

    }
    return(
        <img src={DocumentHyperLink} alt="Undo" className={"documentLink-icon"}
                          style={{cursor:'pointer'}} style={sectionStyle}
                         onClick={paperClipConfirm}/>

    )
})
//icon={faPaperclip} size ="lg"